import { useEffect, useState } from "react";
const useFetchData = (url) => {
  const [data, setdata] = useState(null);
  const [loading, setloading] = useState(true);
  const [error, seterror] = useState("");
  useEffect(() => {
    const url = "https://main-server.malihatabassum.com/books";
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        seterror(data.error);
        setdata(data);
        setloading(false);
      });
  }, [url]);
  return { data, loading, error };
};
export default useFetchData;
